import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCameraOverlayMutations } from '../hooks';
import { VideoPlayerCamera } from 'types';
import { PauseCircleFilled, PlayCircleFilled } from '@mui/icons-material';
import { Tour } from '@kinetic-ui/data-layer';
import useCameraDetailsOverlayStyles from 'components/CameraDetailsOverlay/styles';

export interface TourControlButtonProps {
  data: VideoPlayerCamera;
  refetchData?: () => void;
  tour: Tour;
  isTourPaused?: boolean;
  toggleIsTourPaused?: (tourId: string, paused: boolean) => void;
}

const TourControlButton: React.FunctionComponent<TourControlButtonProps> = (props) => {
  const classes = useCameraDetailsOverlayStyles();
  const { t } = useTranslation(['video', 'common']);

  const { data, refetchData, tour, isTourPaused, toggleIsTourPaused } = props;

  const { toggleIsPaused } = useCameraOverlayMutations(data?.id, refetchData);

  return (
    <>
      {isTourPaused ? (
        <Tooltip placement='top' title={t('common:play')}>
          <IconButton
            onClick={() => {
              toggleIsTourPaused && toggleIsTourPaused(tour.id, false);
              !toggleIsTourPaused && toggleIsPaused(tour.id, false);
            }}
            size='small'
          >
            <PlayCircleFilled className={classes.videoControllsButton} fontSize='small' />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip placement='top' title={t('common:pause')}>
          <IconButton
            onClick={() => {
              toggleIsTourPaused && toggleIsTourPaused(tour.id, true);
              !toggleIsTourPaused && toggleIsPaused(tour.id, true);
            }}
            size='small'
          >
            <PauseCircleFilled className={classes.videoControllsButton} fontSize='small' />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};

export default TourControlButton;
